<template lang="pug">
    .container-restricao.row
        .col-12
            small Foram detectadas as seguintes irregularidades:
    
            .list-group
                a.list-group-item.list-group-item-action
                    .row.text-left
                        label.col-3 Número TAD
    
                        label.col-3 CPF/CNPJ
    
                        label.col-3 Nome
    
                        label.col-3 Fazenda
    
                a.list-group-item.list-group-item-action(
                    v-for='(restricao, index) in dados.restricoes'
                )
                    .row.text-left
                        .col-3
                            span {{ restricao.properties.numero_tad }}
    
                        .col-3
                            span {{ restricao.properties.cpf_cnpj }}
    
                        .col-3.pr-0
                            span {{ restricao.properties.nome_pessoa }}
    
                        .col-3.pr-0
                            .text-wrap(
                                data-toggle='tooltip',
                                data-placement='bottom',
                                :title='restricao.properties.fazenda'
                            ) {{ restricao.properties.fazenda }}
    </template>
    
    <script>
    export default {
        name: 'MoratoriaSojaLista',
    
        props: {
            dados: {
                type: Object,
                required: true
            }
        },
    
        mounted() {
            $(function () {
                $('[data-toggle="tooltip"]').tooltip({ boundary: 'window' });
            });
        }
    };
    </script>
